import React from "react";

function IconListButton() {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.75 6L5.75 6M14.75 1.5L5.75 1.5M14.75 10.5L5.75 10.5M2.75 6C2.75 6.41421 2.41421 6.75 2 6.75C1.58579 6.75 1.25 6.41421 1.25 6C1.25 5.58579 1.58579 5.25 2 5.25C2.41421 5.25 2.75 5.58579 2.75 6ZM2.75 1.5C2.75 1.91421 2.41421 2.25 2 2.25C1.58579 2.25 1.25 1.91421 1.25 1.5C1.25 1.08579 1.58579 0.75 2 0.75C2.41421 0.75 2.75 1.08579 2.75 1.5ZM2.75 10.5C2.75 10.9142 2.41421 11.25 2 11.25C1.58579 11.25 1.25 10.9142 1.25 10.5C1.25 10.0858 1.58579 9.75 2 9.75C2.41421 9.75 2.75 10.0858 2.75 10.5Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IconListButton;
